/* MBG collection-card quick add — toggles the size popover and wires the
   selected size into the hidden variant input. Actually adding to cart is
   handled entirely by the existing mbg-cart.js (it already intercepts any
   .product-form submit), so this file only manages the size-selection UI. */
(function () {
  'use strict';

  document.addEventListener('click', function (evt) {
    var toggle = evt.target.closest('[data-mbg-quick-add-toggle]');
    if (!toggle) {
      return;
    }

    /* This button lives outside both of the card's real <a> links (image
       and title), so nothing to prevent today — but never let a future
       markup change turn this into an accidental navigation. */
    evt.preventDefault();
    evt.stopPropagation();

    var wrapper = toggle.closest('[data-mbg-quick-add]');
    var form = wrapper && wrapper.querySelector('[data-mbg-quick-add-form]');
    if (!form) {
      return;
    }

    var isOpen = !form.hidden;

    closeAllQuickAdd();

    if (!isOpen) {
      form.hidden = false;
      var overlay = wrapper.querySelector('[data-mbg-quick-add-overlay]');
      if (overlay) {
        overlay.hidden = false;
      }
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mbg-quick-add-open');
      var firstOption = form.querySelector('[data-mbg-quick-add-option]:not(:disabled)');
      if (firstOption) {
        firstOption.focus();
      }
    }
  });

  document.addEventListener('change', function (evt) {
    if (!evt.target.matches('[data-mbg-quick-add-option]')) {
      return;
    }
    var sheet = evt.target.closest('[data-mbg-quick-add-form]');
    var form = sheet && sheet.querySelector('form');
    if (!form) {
      return;
    }
    var hiddenInput = form.querySelector('[data-mbg-quick-add-variant-id]');
    if (hiddenInput) {
      hiddenInput.value = evt.target.value;
    }

    /* Selecting an available size adds it immediately — no second "Add
       to cart" click. mbg-cart.js already intercepts this submit (AJAX
       add, cart count update, opens the drawer on success — its own
       .product-form__cart-submit is-loading toggle still runs since that
       button, though visually hidden, is still a real submit target). */
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
    closeAllQuickAdd();
  });

  function closeAllQuickAdd() {
    document.querySelectorAll('[data-mbg-quick-add-form]').forEach(function (openForm) {
      openForm.hidden = true;
    });
    document.querySelectorAll('[data-mbg-quick-add-overlay]').forEach(function (overlay) {
      overlay.hidden = true;
    });
    document.querySelectorAll('[data-mbg-quick-add-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('mbg-quick-add-open');
  }

  /* Explicit close button — same sheet on mobile is full-height enough
     that "click outside" isn't always reachable/obvious, so it needs its
     own close control (see mbg-product-card.liquid). */
  document.addEventListener('click', function (evt) {
    var closeBtn = evt.target.closest('[data-mbg-quick-add-close]');
    if (!closeBtn) {
      return;
    }
    var toggle = closeBtn.closest('[data-mbg-quick-add]').querySelector('[data-mbg-quick-add-toggle]');
    closeAllQuickAdd();
    if (toggle) {
      toggle.focus();
    }
  });

  /* Overlay click closes — the overlay is a fixed-position sibling of the
     sheet inside the same [data-mbg-quick-add] wrapper (so it can sit
     under a centred modal regardless of where in the grid that card is),
     which means the generic "outside click" handler below never sees it
     as outside; it needs its own explicit close. */
  document.addEventListener('click', function (evt) {
    if (evt.target.closest('[data-mbg-quick-add-overlay]')) {
      closeAllQuickAdd();
    }
  });

  /* Close an open quick-add popover on outside click, without interfering
     with the actual add-to-cart submit (handled by mbg-cart.js). */
  document.addEventListener('click', function (evt) {
    if (evt.target.closest('[data-mbg-quick-add]')) {
      return;
    }
    closeAllQuickAdd();
  });

  /* Escape closes it too, matching the cart drawer's own convention. */
  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') {
      closeAllQuickAdd();
    }
  });
})();
